(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleep-qa"] && !Shopify.designMode) return;
  try {
    
async function renderMobilePreview(url){
  const response=await fetch(url,{credentials:'same-origin'});
  if(!response.ok)throw new Error('Aperçu indisponible');
  const html=await response.text();
  const snapshot=html.replace('<head>','<head><base href="'+location.origin+'/">');
  document.querySelectorAll('.sq iframe').forEach(frame=>{frame.srcdoc=snapshot;});
}
document.querySelectorAll('[data-preview-key]').forEach(button=>button.addEventListener('click',()=>{const key=button.dataset.previewKey;const productPaths={ 'product-ear':'/products/cotton-filling-ear-piercing-pillow-for-sleeping-with-ear-relief-hole-ergonomic-side-sleeper-comfort', 'product-knee':'/products/memory-cotton-leg-pillow-ergonomic-leg-support-pillow-relieve-hip-pain-sciatica-leg-alignment-pillow-hip-relief-washable', 'product-travel':'/products/3-in-1-airplane-sleep-support-system-plane-sleeping-accessories-with-memory-foam-long-haul-flight-pillow-adjustable-travel-eye' };const url=key==='home'?'/':key==='cart'?'/cart':productPaths[key]||'/pages/contact?view='+key;renderMobilePreview(url).catch(error=>{document.querySelector('.sq>p').textContent=error.message;});}));
renderMobilePreview('/pages/contact?view=confort-oreille').catch(error=>{document.querySelector('.sq>p').textContent=error.message;});

  } catch(e) { console.error(e); }
})();
})();
